import Banner from "../../../sections/common/banner";
import ItodoImage from "../../../elements/itodo-img";
import { NavLink, useParams } from "react-router-dom";
import { bannerData } from "../../../../globals/banner";
import { caseStudies } from "../../../../globals/neuron-content";
import { useEffect, useMemo } from "react";
import { loadScript } from "../../../../globals/constants";

function OperationDetailPage() {
  const { slug } = useParams();
  const study = useMemo(() => {
    return caseStudies.find((item) => item.slug === slug) ?? caseStudies[0];
  }, [slug]);
  const index = caseStudies.findIndex((item) => item.slug === study.slug);
  const prev = index > 0 ? caseStudies[index - 1] : null;
  const next = index < caseStudies.length - 1 ? caseStudies[index + 1] : null;

  useEffect(() => {
    loadScript("js/custom.js");
  }, []);

  return (
    <>
      <Banner _data={bannerData.operationDetail} />

      <div className="section-full p-t110 mobile-page-padding">
        <div className="container">
          <div className="sx-pic-l">
            <ItodoImage src={study.image} alt={study.title} />
          </div>
          <div className="section-content">
            <div className="section-head left">
              <div className="sx-head-s-title">{study.category}</div>
              <div className="sx-head-l-title">
                <h2 className="sx-title">{study.title}</h2>
              </div>
            </div>
            <div className="sx-our-service-info m-b30">
              <p>{study.summary}</p>
              <p>{study.details}</p>
              <div className="sx-about-icon-bx2-column sx-bg-light m-tb50">
                <div className="row ">
                  <div className="col-lg-3 col-md-6">
                    <div className="sx-icon-bx-6">
                      <div className="sx-media sx-text-secondry">
                        <i className="flaticon-category" />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">Category:</span>
                        <span className="sx-icon-bx-title-info">{study.serviceType}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="sx-icon-bx-6">
                      <div className="sx-media sx-text-secondry">
                        <i className="flaticon-calendar" />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">Date:</span>
                        <span className="sx-icon-bx-title-info">{study.date}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="sx-icon-bx-6">
                      <div className="sx-media sx-text-secondry">
                        <i className="flaticon-leaf" />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">Author:</span>
                        <span className="sx-icon-bx-title-info">{study.author}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="sx-icon-bx-6">
                      <div className="sx-media sx-text-secondry">
                        <i className="flaticon-map-location" />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">Coverage:</span>
                        <span className="sx-icon-bx-title-info">Kenya & Regional Support</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sx-icon-list m-b50">
                <ul className="sx-list-check">
                  {study.highlights.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
              <div className="sx-r-part-image-content-box">
                <div className="row">
                  <div className="col-lg-8 col-md-12">
                    <div className="sx-r-part-content">
                      <h2 className="sx-title">From risk mapping to field execution</h2>
                      <p>We convert risk reviews into practical deployment controls that teams can execute daily. This includes who owns each decision, how incidents are escalated and what reporting reaches client leadership.</p>
                      <p>That delivery rhythm improves accountability and keeps operations stable even when external conditions shift.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div className="sx-r-part-media">
                      <ItodoImage src={study.relatedImages[0]} alt={study.title} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="sx-r-part-image-content-box">
                <div className="row">
                  <div className="col-lg-8 col-md-12">
                    <div className="sx-r-part-content">
                      <h3 className="sx-title">Sustaining performance under pressure</h3>
                      <p>Effective security is not only about initial setup. We monitor execution quality, communication discipline and local context to keep controls relevant and dependable across the assignment lifecycle.</p>
                      <p>That makes each operation safer, more predictable and easier for client teams to manage.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div className="sx-r-part-media">
                      <ItodoImage src={study.relatedImages[1] ?? study.image} alt={study.title} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="s-post-pagination-control previous-next previous next">
            <div className="paging-left paging-item">
              <div className="paging-content">
                <NavLink className="paging-link" to={prev ? `/operations/${prev.slug}` : "/operations"}>
                  <i className="fa fa-long-arrow-left" />
                </NavLink>
                <div className="paging-content-inner">
                  <NavLink className="paging-link2" to={prev ? `/operations/${prev.slug}` : "/operations"}>{prev ? "Previous Case" : "Back to Operations"}</NavLink>
                  <h4 className="paging-title">
                    <NavLink to={prev ? `/operations/${prev.slug}` : "/operations"}>{prev ? prev.title : "All Operations"}</NavLink>
                  </h4>
                </div>
              </div>
            </div>
            <div className="paging-right paging-item">
              <div className="paging-content reverse">
                <NavLink className="paging-link" to={next ? `/operations/${next.slug}` : "/operations"}>
                  <i className="fa fa-long-arrow-right" />
                </NavLink>
                <div className="paging-content-inner">
                  <NavLink className="paging-link2" to={next ? `/operations/${next.slug}` : "/operations"}>{next ? "Next Case" : "All Operations"}</NavLink>
                  <h4 className="paging-title">
                    <NavLink to={next ? `/operations/${next.slug}` : "/operations"}>{next ? next.title : "All Operations"}</NavLink>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-full p-t110 p-b80 sx-bg-white sx-case-study3-outer">
        <div className="container">
          <div className="section-head center">
            <div className="sx-head-s-title">Related Operations</div>
            <div className="sx-head-l-title">
              <h2 className="sx-title">Additional Case Highlights</h2>
            </div>
          </div>
          <div className="section-content">
            <div className="owl-carousel sx-case-st-carousel-2 m-b30">
              {caseStudies
                .filter((item) => item.slug !== study.slug)
                .slice(0, 4)
                .map((item) => (
                  <div className="item" key={item.slug}>
                    <div className="sx-case-study-bx three-blocks sx-overlay-effect">
                      <div className="sx-case-media sx-img-overlay">
                        <NavLink to={`/operations/${item.slug}`}><ItodoImage src={item.image} alt={item.title} /></NavLink>
                        <NavLink to={`/operations/${item.slug}`} className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                      </div>
                      <div className="sx-case-info">
                        <div className="sx-s-title">{item.category}</div>
                        <NavLink className="sx-l-title" to={`/operations/${item.slug}`}>
                          <h2 className="sx-title">{item.title}</h2>
                        </NavLink>
                        <div className="sx-case-readmore">
                          <NavLink to={`/operations/${item.slug}`} title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa fa-long-arrow-right" />Read More</NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationDetailPage;
